import React, { useEffect, useRef } from "react";
import { useGlobalContext } from "../../../providers/global";
import {
  ContactAvatar,
  StyledMessageCenter,
  StyledMessageContainer,
  StyledMessageMessageCenterHeader
} from "./Chat.style";
import MessageCard from "./MessageCard/MessageCard.component";
import SendMessage from "./SendMessage/SendMessage.component";

const defaultAvatar = "https://www.w3schools.com/howto/img_avatar.png";

const Chat = ({ chat }) => {
  const { currentUser } = useGlobalContext();
  const participantsWithoutCurrentUser = chat.participants.filter(
    p => p.id !== currentUser.id
  );
  const messageContainerRef = useRef();
  const scrollToBottom = () => {
    if (messageContainerRef.current) {
      setTimeout(() => {
        messageContainerRef.current.scrollTop =
          messageContainerRef.current.scrollHeight;
      });
    }
  };

  scrollToBottom();

  useEffect(() => {
    scrollToBottom();
  }, []);

  return (
    <StyledMessageContainer>
      <div style={{ flex: 1 }}>
        <StyledMessageMessageCenterHeader>
          <ContactAvatar
            src={participantsWithoutCurrentUser[0].image || defaultAvatar}
            alt={participantsWithoutCurrentUser[0].name}
          />
          {participantsWithoutCurrentUser.map(p => p.name).join(", ")}
        </StyledMessageMessageCenterHeader>
        <StyledMessageCenter ref={messageContainerRef}>
          <MessageCard
            containerRef={messageContainerRef}
            participants={chat.participants}
            messages={chat.messages}
          />
        </StyledMessageCenter>
        <div>
          <SendMessage />
        </div>
      </div>

      {/* <Attachment /> */}
    </StyledMessageContainer>
  );
};

export default Chat;
